import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';


@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-rs009-card-IV',
    templateUrl: './rs009-card-IV.component.html'
})

export class Rs009CardIVComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;

    @Output() objMakeCalculations = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Etapa 4', false);

        this.formulario = this.formBuilder.group({
            Sementes: [null, []],
            Sub_Total_Desc_Grao_g: [null, []],
            Sub_Total_Desc_Grao_porc: [null, []],
            Umidade_Deduzir: [null, []],
            Desc_Impu_Palh: [null, []],
            Desc_Sabugo: [null, []],
            Total_Desc_Pal_Imp_Sabugo: [null, []],
            Peso_Liquido_Umido: [null, []],
        });
    }

    async ngOnInit(): Promise<void> {
    }

    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public async makeCalculations(): Promise<void> {
        this.objMakeCalculations.emit();
    }
}

